import { render } from "./DeleteAlert.vue?vue&type=template&id=32885796&scoped=true"
import script from "./DeleteAlert.vue?vue&type=script&lang=js"
export * from "./DeleteAlert.vue?vue&type=script&lang=js"

import "./DeleteAlert.vue?vue&type=style&index=0&id=32885796&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32885796"]])

export default __exports__